import { TabsWidget } from "./TabsWidget.js";
import { GridWidget } from "./widgets/GridWidget.js";
import { CTAButton } from "./widgets/CTAButton.js";
import { CalculatorWidget } from "./widgets/CalculatorWidget.js";
import { Modal } from "./Modal.js";
import { DealPage } from "./DealPage.js";
import { FinancingForm } from "./FinancingForm.js";
import { TradeIn } from "./TradeIn.js";
import { PmDRSDatalayer } from "../Datalayer/PmDRSDatalayer.js";
import { ShiftDatalayer } from "../Datalayer/ShiftDatalayer.js";
import { AdobeDtmDatalayer } from "../Datalayer/AdobeDtmDatalayer.js";
import { RequestHelper } from "../Helpers/RequestHelper.js";
import { PmDrsForms } from "./common/PmDrsForms.js";
import { FormatHelper } from "../Helpers/FormatHelper.js";
import { DOMHelper } from "../Helpers/DOMHelper.js";

export class FrontApp {
    constructor(pmdrs, config) {
        let app = this;
        app.pmdrs = pmdrs;
        //CONFIG
        this.config = this.defaultConfig();
        Object.assign(this.config, config);

        //fixes
        //use MSRP as final if final is 0        
        if (this.config.vehicle.finalPrice == 0) {
            this.config.vehicle.finalPrice = this.getVehicleRetailPrice();
        }
        //filter only enabled accessories
        // filter only enabled accessories
        let accessories = this.config.vehicle.accessories || {};
        this.config.vehicle.accessories = Object.fromEntries(
            Object.entries(accessories).filter(([_, acc]) => acc && acc.enabled)
        );
        this.minimumAmountFinanced = 0;
        this.setMinimumAmountFinanced(5000);

        
        //ATTS
        this.defaultDealType = null;
        this.initCallBack = null;
        this.wrapperClass = "pmdrs";
        this.wrapperClassId = "pmdrs-" + this.config.elementId;
        this.themeClass = this.pmdrs.dataDriver.getThemeClass();
        this.paymentData = {//it'll contain a key by dealType: finance, lease, cash, premier, ttf, balloon when apply
            taxesAndFeesTotal: 0,//this will be moved to each paymentData type, is it in use?
            tradeInData: {},
        };        

        // Get the current URL query string
        const queryString = window.location.search;
        const urlParams = new URLSearchParams(queryString);
        this.forceGridWidget = urlParams.get('useGridWidget') === 'true';
        this.forceOnlyButtonOnVdp = urlParams.get('onlyButtonOnVDP') === 'true';
        this.forceCalculatorWidget = urlParams.get('useCalculatorWidget') === 'true' || this.config.forceCalculatorWidget === true;
        this.forceContactFormAtBottom = urlParams.has('contactFormAtBottom') ? urlParams.get('contactFormAtBottom') === 'true' : null;
        this.forceSectionsUnlockedByDefault = urlParams.has('sectionsUnlockedByDefault') ? urlParams.get('sectionsUnlockedByDefault') === 'true' : null;

        //GET PM SITE SETTINGS <-- THIS SHOULD BE THE ONLY ONE API CALL FOR PM SETTINGS
        app.pmdrs.pmApi.pmSiteSettings.getPmSettings(
            app.pmdrs.config.accountId,
            {},
            // SUCCESS
            (response) => {
                var settings = JSON.parse(response);
                app.siteSettings = settings;
                if (this.forceContactFormAtBottom !== null) {
                    app.siteSettings.contactFormAtBottom = this.forceContactFormAtBottom;
                }
                if (this.forceSectionsUnlockedByDefault !== null) {
                    app.siteSettings.sectionsUnlockedByDefault = this.forceSectionsUnlockedByDefault;
                }
                if (
                    settings.enable &&
                    app.onlyAdminsCheck() &&
                    this.config.vehicle.finalPrice != 0 &&
                    this.getVehicleRetailPrice() != 0 
                    //&& this.config.vehicle.condition == "new"//DRA is now for any vehicles
                ) {
                    //CONFIG FROM API THEN INIT
                    this.setDriverConfig();
                } else {
                    console.info("PMDRS not enabled");
                }
            },
            // ERROR
            (response) => {
                console.error("Error getting PM Site Settings");
            }
        );

        // this.init();
    }

    onlyAdminsCheck() {
        return !this.siteSettings.onlyAdmins || (this.siteSettings.onlyAdmins && this.pmdrs.config.adminLoggedIn);
    }

    getBalloonType(){
        if(this.isVehicleDucati()) return 'premier';
        if(this.isVehicleTriumph()) return 'ttf';
        return 'easyride';
    }

    

    isVehicleDucati(){
        return this.config.vehicle.make.toLowerCase() == "ducati";
    }

    isVehiclePolaris() {
        return this.config.vehicle.make.toLowerCase() == "polaris";
    }

    isVehicleJeep() {
        return this.config.vehicle.make.toLowerCase() == "jeep";
    }

    isVehicleRam() {
        return this.config.vehicle.make.toLowerCase() == "ram";
    }

    isVehicleDodge() {
        return this.config.vehicle.make.toLowerCase() == "dodge";
    }

    isVehicleChrysler() {
        return this.config.vehicle.make.toLowerCase() == "chrysler";
    }

    isVehicleStellantis() {
        return this.isVehicleChrysler() || this.isVehicleDodge() || this.isVehicleJeep() || this.isVehicleRam();
    }

    isVehicleFord() {
        return this.config.vehicle.make.toLowerCase() == "ford";
    }

    isVehicleCanam() {
        return this.config.vehicle.make.toLowerCase() == "can-am";
    }

    isVehicleTriumph() {
        return this.config.vehicle.make.toLowerCase() == "triumph";
    }

    isVehicleHarleyDavidson() {
        return this.config.vehicle.make.toLowerCase() == "harley-davidson";
    }

    isVehicleRoyalEnfield() {
        return this.config.vehicle.make.toLowerCase() == "royal enfield";
    }

    isVehicleOnlyFinance(make) {
        make = make.toLowerCase();
        let makeList = ['polaris', 'royal enfield', 'indian motorcycle', 'cfmoto', 'honda', 'suzuki', 'yamaha', 'kawasaki'];
        return makeList.includes(make);
    }

    isBMW() {
        return this.config.vehicle.make.toLowerCase() == "bmw" && this.pmdrs.getOEM() == "bmwmotorrad";
    }

    isBMWPolaris() {
        return this.pmdrs.getOEM() == "bmwmotorrad_polaris";
    }

    setMinimumAmountFinanced(minimumAmountFinanced) {
        this.minimumAmountFinanced = minimumAmountFinanced;
    }

    getMinimumAmountFinanced() {
        return this.minimumAmountFinanced;
    }

    isLampedodge() {
        return this.pmdrs.config.accountId === 'lampedodge';
    }

    isSouthbayChryslerJeepDodgeRam() {
        return this.pmdrs.config.accountId === 'southbaychryslerjeepdodgeram';
    }

    init() {
        let app = this;
        this.addHtml();
        
        if(this.siteSettings.onlyButtonOnVDP || this.forceOnlyButtonOnVdp){
            this.widget = new CTAButton(this, this.config.vehicle);        
            this.widget.init({}, true);//force it 
        }
        else if(this.siteSettings.useGridWidget || this.forceGridWidget ){//GridWdiget
            this.widget = new GridWidget(this, this.config.vehicle);        
            let initialPayments = this.pmdrs.dataDriver.getFormatedInitialPayments();
            // begging - workaround type only for grid widget for delamo
            let pData = this.pmdrs.dataDriver.initialPayments['finance_lower_rate'];
            if(pData){
                initialPayments['finance_lower_rate'] = this.pmdrs.dataDriver.formatApiPayment(pData);
            }
            // end - workaround type only for grid widget for delamo
            this.widget
                .setParentContainerSelector(this.getSelector(''))
                .setShowButton(true)
                .setShowAllDealTypes(true);
            this.widget.init(initialPayments);
        }
        else if(this.siteSettings.useCalculatorWidget || this.forceCalculatorWidget){//CalculatorWidget
            this.widget = new CalculatorWidget(this, this.config.vehicle);
            this.widget.init();
        }else{
            this.widget = new TabsWidget(this, this.config.vehicle);
            this.widget.init();
        }

        this.widget.setBtnClickCallback((dealType)=>{
            dealType = dealType || app.getDefaultDealType();
            if (this.widget.paymentsData && !this.widget.paymentsData[dealType]) {
                dealType = Object.keys(this.widget.paymentsData)[0] || dealType;
            }
            //calling first the modal in case CJ crashes
            app.callDealModalShow(dealType);
            //DATALAYER
            app.adobeDtmDatalayer.fireEvent('buttonClick', {btnText: app.siteSettings.vlp_btn_text});            

            // this.initCustomerJourney(app);
        });

        //PMDRS Forms
        this.pmdrsForms = new PmDrsForms(this);

        //DEAL PAGE
        this.dealPage = new DealPage(this);
        //deal page modal
        this.dealModal = new Modal(this, "start-deal-modal", this.dealPage.getHtml(), null, "whole-screen");
        var htmlElement = document.querySelector("html");
        var leadFormShown = false;
        var toolStarted = false;
        this.dealModal.setShowCallback(() => {
            htmlElement.classList.add("pmdrs-active");
            app.dealPage.registerStickyHeaderHandler();
            //DATALAYER
            this.shiftDatalayer.fireEvent('formShown', {formType: 'Other'});
            this.shiftDatalayer.fireEvent('drPageView', {withClick: false, dealType: this.dealPage.dealType});
            if(!leadFormShown){
                this.shiftDatalayer.fireEvent('drLeadFormShown', {ftid: this.dealPage.ftid});
                leadFormShown = true;
            }
            
            if(!toolStarted){
                this.adobeDtmDatalayer.fireEvent('toolStart');
                toolStarted = true;
            }

            this.adobeDtmDatalayer.fireEvent('jsVirtualPageView', {});            
        });

        this.dealModal.setHideCallback(() => {
            htmlElement.classList.remove("pmdrs-active");

            //DATALAYER
            if(this.dealPage.drsCustomerId.length > 0){//if user created fire drDropSave
                this.shiftDatalayer.fireEvent('drDropSave');
            }
            this.adobeDtmDatalayer.fireEvent('closeDrs');

        });

        //init first modal to add html before handlers
        this.dealModal.init();        
        this.dealPage.init();
        this.pmdrsForms.init();

        //TRADE IN
        this.tradeIn = new TradeIn(this);
        this.tradeIn.setSubmitCallback((data) => {
            app.widget.tradeInCallback(data); //SENDING IT DIRECTLY MAKE 'this' PROBLEMS
        });

        //trade in modal
        this.tradeInModal = new Modal(this, "trade-in-modal", this.tradeIn.getHtml(), ".open-trade-in-btn");
        this.tradeInModal.init();
        this.tradeIn.init();

        //FINANCING FROM
        this.financingForm = new FinancingForm(this);
        //deal page modal
        this.financingFormModal = new Modal(
            this,
            "financing-form-modal",
            this.financingForm.getHtml(),
            null,
            "large-modal"
        );
        //init first modal to add html before handlers
        this.financingFormModal.init();
        this.financingForm.init();
        
        //DATALAYER
        app.pmDRSDatalayer = new PmDRSDatalayer(app);
        RequestHelper.getIPAddress((ipAddress)=>{
            app.pmDRSDatalayer.setIpAddress(ipAddress);
            app.pmDRSDatalayer.init();
        })
        //SHIFT DATALAYER
        this.shiftDatalayer = new ShiftDatalayer(this.pmdrs, this.config.vehicle);
        this.shiftDatalayer.init();
        this.shiftDatalayer.setFTID(this.dealPage.ftid);
        this.addShiftDataLayerHandlers();

        //ADOBE DTM DATALAYER
        this.adobeDtmDatalayer = new AdobeDtmDatalayer(this.pmdrs, this.config.vehicle);
        if(this.adobeDtmDatalayer.init()){
            this.addAdobeDtmDataLayerHandlers();
        }

        //auto open deal modal
        if(this.config.hideWidget) {
            let dealType = this.getDefaultDealType();
            // if(this.widget instanceof TabsWidget){//v2
            this.callDealModalShow(dealType);
            // }else{//this will be gone when PM driver uses TabsWidget
            //     this.dealPage.dealType = dealType;
            //     this.dealPage.paymentSection.refreshAllPayments();
            //     this.dealModal.show();
            // }
        }

        if (this.initCallBack) {
            this.initCallBack();
        }
        this.fireDrsAppUpdatedEvent();                  
    }

     fireDrsAppUpdatedEvent(){
        document.body.dispatchEvent(new Event('drsapp:updated'));
    }

    initCustomerJourney(app) {
        //customer journey starts
        let data = {
            sessionId: app.pmDRSDatalayer.getSessionId(),
            siteToken: app.pmdrs.config.accountId,
            sessionIdSource: app.pmdrs.sessionIdSource || "host",
        };
        app.pmdrs.pmCustomerAPI.createCustomerJourneyCTA(data,
            (response) => {
                console.log("Creating CJ status partial-cta-click");
                response = JSON.parse(response);
                app.dealPage.customerJourneyId = response.id;
                console.log(response);
            }, 
            (error) => {
                console.log(error);
            }            
        );//customer journey ends
    }

    generateLeadId() {
        if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') return crypto.randomUUID();
        
        // 2. Define the time variables within the function's scope
        let d = new Date().getTime(); // Milliseconds since epoch
        let d2 = (performance && performance.now && (performance.now() * 1000)) || 0; // High-res time, fall back to 0 if not available

        // 3. Perform the V4-like UUID generation
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
            let r = Math.random() * 16;
            
            // This logic uses the defined 'd' and 'd2' variables
            if (d > 0) {
                r = (d + r) % 16 | 0;
                d = Math.floor(d / 16);
            } else {
                r = (d2 + r) % 16 | 0;
                d2 = Math.floor(d2 / 16);
            }

            // Standard V4 UUID logic
            return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16);
        });
    }

    generateFTID(leadId) {        
        const uuid = leadId;

        // Get the current date and format it as ISO string
        const now = new Date();
        const formattedDate = now.toISOString().slice(0, 19); // Format: YYYY-MM-DDTHH:MM:SS

        // Combine UUID and date with a colon separator
        return `${uuid}:${formattedDate}`;
    }

    addShiftDataLayerHandlers(){
        var dataLayer = this.shiftDatalayer;
        //FORM INTERACTION AND INIT EVENTS
        var inputEvents = [
            { selector: 'form.deal-page-form input', formType: 'Other'},            
        ];

        inputEvents.forEach(item => {
            DOMHelper.addHandler(
                this.getSelector(item.selector),
                "focusin", 
                (event) => {   
                    let args = {
                        formType: item.formType,
                        formFieldName: event.target.name
                    }
                    dataLayer.fireEvent('formFieldInteraction', args);
                    if(dataLayer.initiatedForms[item.selector]){
                        return;//skip double
                    }
                    dataLayer.fireEvent('formInitiation', args);
                    dataLayer.fireEvent('drLeadFormStart');
                    dataLayer.initiatedForms[item.selector] = true;
                }
            );
        });

        //TRADE IN STARTS EVENTS
        DOMHelper.addHandler(this.getSelector('.tradein-section input'),
            "focusin", 
            (event) => {   
                if(dataLayer.startedSections['tradein']){
                    return;//skip double
                }
                dataLayer.fireEvent('drTradeInStart');
                dataLayer.startedSections['tradein'] = true;
            }
        );

        //SCHEDULE TEST RIDE STARTS EVENTS
        DOMHelper.addHandler(this.getSelector('.test-ride input'),
            "focusin", 
            (event) => {   
                if(dataLayer.startedSections['scheduleTestRide']){
                    return;//skip double
                }
                dataLayer.fireEvent('drApptSchedStart');
                dataLayer.startedSections['scheduleTestRide'] = true;
            }
        );

        //PRE APPROVED STARTS EVENTS
        DOMHelper.addHandler(this.getSelector('.pre-approved input'),
            "focusin", 
            (event) => {   
                if(dataLayer.startedSections['preApproved']){
                    return;//skip double
                }
                dataLayer.fireEvent('drPreQStart');
                dataLayer.startedSections['preApproved'] = true;
            }
        );

         //CHAT CLICK EVENT + IMPRESSION
        DOMHelper.addHandler(//
            this.getSelector('.need-help-btn'),
            "click", 
            (event) => {   
                let args = {}
                dataLayer.fireEvent('chatImpression', args);                
                dataLayer.fireEvent('chatClick', args);
            }
        );

        //ACCESSORY ITEM SHOWN 
        /**
         * drFiShown Event fires when the user is first shown 
         * any non- physical add ons (protection/ warranties/ 
         * service packages)
         * */
        var fiShownFired = false;      
        const checkFiShown = () => {
            let accessory = this.dealPage.accessoriesSection?.getCurrentDisplayedAccessory();
            if(accessory?.product_type == 'package'){//add waranties check
                dataLayer.fireEvent('drFiShown', {accessory});                                
                fiShownFired = true;    
            }   
        }  
        DOMHelper.addHandler(//
            this.getSelector('.accessories-section .slider-right')
            + ", " + this.getSelector('.accessories-section .slider-left'),
            "click", 
            (event) => {   
                if(!fiShownFired){
                    checkFiShown();                     
                }
            }
        );

        //SCROLL SHOWN EVENTS
        var accessoriesShownFired = false;
        var accessoriesFinishedFired = false;
        var paymentSectionShownFired = false;
        var paymentCalcFinishedFired = false;
        var creditAppShownFired = false;
        DOMHelper.addHandler(this.getSelector('.start-deal-modal'),
            "scroll",
            () => {
                //accessories shown
                if(!accessoriesShownFired){
                    if(DOMHelper.isElementInViewport(this.getSelector('.accessories-section'))){
                        dataLayer.fireEvent('drAccessoriesShown')
                        accessoriesShownFired = true;
                        //additional
                        checkFiShown();
                    }
                }
                //accessories finished
                if(accessoriesShownFired && !accessoriesFinishedFired){
                    if(DOMHelper.isElementInViewport(this.getSelector('.tradein-section'))
                        || DOMHelper.isElementInViewport(this.getSelector('.your-payment-title'))
                        ){
                        dataLayer.fireEvent('drAccessoriesFinish')
                        dataLayer.fireEvent('drFiFinish')
                        accessoriesFinishedFired = true;
                    }
                }

                //payment calculator section shown
                if(!paymentSectionShownFired){
                    if(DOMHelper.isElementInViewport(this.getSelector('.your-payment-title'))){
                        dataLayer.fireEvent('drPaymentCalcShown')
                        paymentSectionShownFired = true;
                    }
                }

                //payment calculator finished
                if(!paymentCalcFinishedFired){
                    if(DOMHelper.isElementInViewport(this.getSelector('.payment-summary-section .submit-button'))){
                        dataLayer.fireEvent('drPaymentCalcFinish')
                        paymentCalcFinishedFired = true;
                    }
                }

                //credit application button shown (FCA only)
                if(!creditAppShownFired && this.pmdrs.isFCA()){
                    if(DOMHelper.isElementInViewport(this.getSelector('.start-application-button'))){
                        dataLayer.fireEvent('drCreditAppShown', {})
                        creditAppShownFired = true;
                    }
                }
            }
        );

        //SHIFT CALCULATOR INTERACTION
        // var paymentCalcInteractionFired = false;  //commented out to fire multiple times     
        DOMHelper.addHandler(//
            this.getSelector('.your-payment-section input')
            + ", "+ this.getSelector('.your-payment-section select'),
            "change", 
            (event) => {   
                // if(!paymentCalcInteractionFired){
                    dataLayer.fireEvent('drPaymentCalcInteraction');                                
                    // paymentCalcInteractionFired = true;
                // }
            }
        );

        DOMHelper.addHandler(
            this.getSelector('.payment-option-box .click-curtain'),
            "click",
            (event) => {
                let dealType = event.target.parentElement.dataset.type;
                dataLayer.fireEvent('drPaymentCalcInteraction', {dealType});
            }
        );

        //APPOINTMENT CALENDAR SHOWN 
        var calendarShownFired = false;        
        DOMHelper.addHandler(//
            this.getSelector('.scheduleTestRideBtn'),
            "click", 
            (event) => {   
                if(!calendarShownFired){
                    dataLayer.fireEvent('drApptSchedShown');                                
                    calendarShownFired = true;
                }
            }
        );

        //PRE APPROVED CALENDAR SHOWN 
        var preApprovedShownFired = false;        
        DOMHelper.addHandler(//
            this.getSelector('.preApprovedBtn'),
            "click", 
            (event) => {   
                if(!preApprovedShownFired){
                    dataLayer.fireEvent('drPreQShown');                                
                    preApprovedShownFired = true;
                }
            }
        );    
    }

    addAdobeDtmDataLayerHandlers(){
        var $this = this;
        var dataLayer = this.adobeDtmDatalayer;

        //SCROLL TO CLICK
        DOMHelper.addHandler(this.getSelector('.bmwdrs-floatnav a'),
            "click", 
            (event) => { 
                const aTag = event.target;
                const selector = $this.getSelector('.bmwdrs-floatnav a');
                let domIndex = [...document.querySelectorAll(selector)].indexOf(aTag); 
                let btnText = 'scroll-to-' + domIndex;
                dataLayer.fireEvent('buttonClick', {btnText});
            }
        );

        //GENERAL INTERACTIONS
        var clickEvents = [
            { selector: '.header-info-section a.vehicle-details'},            
            { selector: '.header-info-section a.disclaimer-title'},            
            { selector: '.disclaimer-modal .drs-close-modal-btn', btnText:"payment-disclaimer-overlay-close"},            
            { selector: '.see-details .drs-close-modal-btn', btnText:"vehicle-details-overlay-close"},            
            { selector: 'a.need-help-btn', btnText:"video-chat-open"},                        
            { selector: '.start-need-help-modal .drs-close-modal-btn', btnText:"video-chat-overlay-close"},                        
            { selector: '.start-need-help-modal button', btnText:"video-chat-overlay-submit"},                        
            { selector: 'input.contact-form-button', btnText:"contact-information-submit-and-continue"},
            { selector: '.start-contact-confirmation .drs-close-modal-btn', btnText:"contact-information-confirmation-overlay-close"},
            { selector: '.contact-confirmation-btn', btnText:"contact-information-confirmation-overlay-continue"},
            { selector: '.tradein-search-btn', btnText:"trade-in-vin-search"},
            { selector: '.tradein-section .addbtn', btnText:"trade-in-upload-images"},
            { selector: '.start-drag-and-drop-modal .drs-close-modal-btn', btnText:"upload-images-overlay-close"},
            { selector: '.start-drag-and-drop-modal .submit-button-close', btnText:"upload-images-overlay-close"},
            { selector: '.start-drag-and-drop-modal .ua-uploadsubmit', btnText:"upload-images-overlay-upload"},
            { selector: '.start-drag-and-drop-modal .ua-uploadselect a', btnText:"upload-images-select-images"},
            { selector: 'input[name="tradeDateField"]', btnText:"trade-in-date-selected"},
            { selector: 'a.finance-disclaimer-btn', btnText:"payment-finance-disclaimer-open"},
            { selector: 'a.lease-disclaimer-btn', btnText:"payment-lease-disclaimer-open"},
            { selector: 'a.cash-disclaimer-btn', btnText:"payment-cash-disclaimer-open"},
            { selector: '.apply-down-payment-button', btnText:"apply-deposit"},
            { selector: '.your-payment-section .submit-button', btnText:"summary-finish-and-send"},
            { selector: '.scheduleTestRideBtn', btnText:"schedule-test-ride-expand"},
            { selector: '.test-ride-body-title', btnText:"schedule-test-ride-collapse"},
            { selector: '.submitTestRide', btnText:"schedule-a-test-drive-submit"},
            { selector: '.preApprovedBtn', btnText:"get-pre-approved-expand"},
            { selector: '.pre-approved-body-title', btnText:"get-pre-approved-collapse"},
            { selector: '.submitPreApproved', btnText:"get-pre-approved-submit"},

        ];

        clickEvents.forEach(item => {
            DOMHelper.addHandler(
                this.getSelector(item.selector),
                "click", 
                (event) => {   
                    let args = {
                        btnText: item.btnText || event.target.textContent
                    }
                    dataLayer.fireEvent('buttonClick', args);                    
                }
            );
        });

        //Payment Box Click
        DOMHelper.addHandler(//
            this.getSelector('.payment-option-box .click-curtain'),
            "click", 
            (event) => {   
                let type = event.target.parentElement.dataset.type;
                let btnText = 'payment-option-'+type;
                dataLayer.fireEvent('buttonClick',{btnText});
            }
        );

        //Payment Box Dropdowns
        DOMHelper.addHandler(this.getSelector('.payment-option-box select'),
            "change", 
            (event) => {   
                let select = event.target;
                let type = select.parentElement.dataset.type;
                let selectType = select.dataset.valuetype;
                let selectValue = select.value;
                switch(selectType){
                    case 'term': 
                        selectValue+="-months"; 
                        break;
                }
                let btnText = `payment-${type}-${selectType}-${selectValue}`;
                dataLayer.fireEvent('buttonClick',{btnText});
            }
        );

        //CREDIT SCORE CHANGES
        DOMHelper.addHandler(this.getSelector('.retailing-credit-score-select'),
            "change", 
            (event) => {   
                let select = event.target;                
                let selectedOption = select.options[select.selectedIndex];                
                let optionText = selectedOption.textContent 
                    +"-"+ selectedOption.dataset.min 
                    + "-" + selectedOption.dataset.max;
                optionText = optionText.replace(" ",'-').toLowerCase();
                let btnText = `credit-score-${optionText}`;
                dataLayer.fireEvent('buttonClick',{btnText});
            }
        );

        //MAKE A DEPOSIT CHANGES
        DOMHelper.addHandler(this.getSelector('.make-a-deposit'),
            "change", 
            (event) => {   
                let value = event.target.value;                
                let btnText = `make-a-deposit-${value}`;
                dataLayer.fireEvent('buttonClick',{btnText});
            }
        );

        //MAKE A DEPOSIT CHANGES
        DOMHelper.addHandler(this.dealPage.paymentSection.getTaxesBtn(),
            "click", 
            (event) => {   
                let value = event.target.textContent
                    .toLowerCase()
                    .includes('add') ? 'add' : 'remove';                
                let btnText = `summary-${value}-fees-and-taxes`;
                dataLayer.fireEvent('buttonClick',{btnText});
            }
        );

         //FORM INIT EVENTS
         var inputEvents = [
            { selector: 'form.deal-page-form input', formType: 'contact-information'},            
            { selector: '.test-ride-body input', formType: 'test-ride'},            
            { selector: '.pre-approved-body input', formType: 'get-pre-approved'},            
        ];

        inputEvents.forEach(item => {
            DOMHelper.addHandler(
                this.getSelector(item.selector),
                "focusin", 
                (event) => {   
                    if(dataLayer.initiatedForms[item.formType]){
                        return;//skip double
                    }
                    dataLayer.fireEvent('formInit', {formType: item.formType});
                    dataLayer.initiatedForms[item.formType] = true;
                }
            );
        });

         DOMHelper.addHandler(this.getSelector('.your-payment-section .submit-button'),
            "click", 
            (event) => {   
                let formType = 'confirm-deal'
                if(dataLayer.initiatedForms[formType]){
                    return;//skip double
                }
                dataLayer.fireEvent('formInit', {formType: formType});
                dataLayer.initiatedForms[formType] = true;
            }
        );
        return;

        //SCHEDULE TEST RIDE STARTS EVENTS
        DOMHelper.addHandler(this.getSelector('.test-ride input'),
            "focusin", 
            (event) => {   
                if(dataLayer.startedSections['scheduleTestRide']){
                    return;//skip double
                }
                dataLayer.fireEvent('drApptSchedStart');
                dataLayer.startedSections['scheduleTestRide'] = true;
            }
        );

        //PRE APPROVED STARTS EVENTS
        DOMHelper.addHandler(this.getSelector('.pre-approved input'),
            "focusin", 
            (event) => {   
                if(dataLayer.startedSections['preApproved']){
                    return;//skip double
                }
                dataLayer.fireEvent('drPreQStart');
                dataLayer.startedSections['preApproved'] = true;
            }
        );

         //CHAT CLICK EVENT + IMPRESSION
        DOMHelper.addHandler(//
            this.getSelector('.need-help-btn'),
            "click", 
            (event) => {   
                let args = {}
                dataLayer.fireEvent('chatImpression', args);                
                dataLayer.fireEvent('chatClick', args);
            }
        );

        //ACCESSORY ITEM SHOWN 
        /**
         * drFiShown Event fires when the user is first shown 
         * any non- physical add ons (protection/ warranties/ 
         * service packages)
         * */
        var fiShownFired = false;      
        const checkFiShown = () => {
            let accessory = this.dealPage.accessoriesSection?.getCurrentDisplayedAccessory();
            if(accessory?.product_type == 'package'){//add waranties check
                dataLayer.fireEvent('drFiShown', {accessory});                                
                fiShownFired = true;    
            }   
        }  
        DOMHelper.addHandler(//
            this.getSelector('.accessories-section .slider-right')
            + ", " + this.getSelector('.accessories-section .slider-left'),
            "click", 
            (event) => {   
                if(!fiShownFired){
                    checkFiShown();                     
                }
            }
        );

        //SCROLL SHOWN EVENTS
        var accessoriesShownFired = false;
        var accessoriesFinishedFired = false;
        var paymentSectionShownFired = false;
        var paymentCalcFinishedFired = false;
        DOMHelper.addHandler(this.getSelector('.start-deal-modal'),
            "scroll", 
            () => {
                //accessories shown
                if(!accessoriesShownFired){                    
                    if(DOMHelper.isElementInViewport(this.getSelector('.accessories-section'))){
                        dataLayer.fireEvent('drAccessoriesShown')
                        accessoriesShownFired = true;
                        //additional
                        checkFiShown();
                    }
                }
                //accessories finished
                if(!accessoriesFinishedFired){                    
                    if(DOMHelper.isElementInViewport(this.getSelector('.tradein-section'))
                        || DOMHelper.isElementInViewport(this.getSelector('.your-payment-section'))
                        ){
                        dataLayer.fireEvent('drAccessoriesFinish')
                        dataLayer.fireEvent('drFiFinish')
                        accessoriesFinishedFired = true;
                    }
                }

                //payment calculator section shown
                if(!paymentSectionShownFired){                    
                    if(DOMHelper.isElementInViewport(this.getSelector('.your-payment-section'))){
                        dataLayer.fireEvent('drPaymentCalcShown')
                        paymentSectionShownFired = true;
                    }
                }

                //payment calculator finished
                if(!paymentCalcFinishedFired){                    
                    if(DOMHelper.isElementInViewport(this.getSelector('.payment-summary-section .submit-button'))){
                        dataLayer.fireEvent('drPaymentCalcFinish')
                        paymentCalcFinishedFired = true;
                    }
                }
            }
        );

        //CALCULATOR INTERACTION
        var paymentCalcInteractionFired = false;        
        DOMHelper.addHandler(//
            this.getSelector('.your-payment-section input')
            + ", "+ this.getSelector('.your-payment-section select'),
            "change", 
            (event) => {   
                if(!paymentCalcInteractionFired){
                    dataLayer.fireEvent('drPaymentCalcInteraction');                                
                    paymentCalcInteractionFired = true;
                }
            }
        );

        //APPOINTMENT CALENDAR SHOWN 
        var calendarShownFired = false;        
        DOMHelper.addHandler(//
            this.getSelector('.scheduleTestRideBtn'),
            "click", 
            (event) => {   
                if(!calendarShownFired){
                    dataLayer.fireEvent('drApptSchedShown');                                
                    calendarShownFired = true;
                }
            }
        );

        //PRE APPROVED CALENDAR SHOWN 
        var preApprovedShownFired = false;        
        DOMHelper.addHandler(//
            this.getSelector('.preApprovedBtn'),
            "click", 
            (event) => {   
                if(!preApprovedShownFired){
                    dataLayer.fireEvent('drPreQShown');                                
                    preApprovedShownFired = true;
                }
            }
        );    
    }

    setBlurBackground() {
        let modal = document.querySelector(".pm-drs-modal.whole-screen");
        modal.classList.add("backdrop-filter");
    }

    callDealModalShow(dealType){
        var app = this;
        app.dealPage.paymentSection.selectDealType(dealType, false);//flag false, becaue we'll call refreshAllPayments
        // app.widget.paymentData[dealType].tradeIn = app.widget.getTradeIn(dealType);// no trade in btm
        //copy payment data
        var paymentsData = app.widget.paymentsData || this.pmdrs.dataDriver.getFormatedInitialPayments();
        app.pmdrs.allDealTypes.forEach(dealType => {      
            app.setPaymentData(dealType, paymentsData[dealType]);
        });      
        app.dealPage.paymentSection.displayCurrentPayments();
        app.dealPage.paymentSection.preCachePayments();
        app.setBlurBackground();
        app.dealModal.show();
    }

    setDefaultDealType(dealType){
        this.defaultDealType = dealType;
    }

    getDefaultDealType() {
        if(this.defaultDealType) return this.defaultDealType;//it works as an override
        if(this.siteSettings?.default_tab) return this.siteSettings.default_tab;

        if (this.pmdrs.dataDriver.isLenderDesk()) return "lease";
        if (this.config.vehicle.make.toLowerCase() == "ducati") return "balloon";
        if (this.config.vehicle.make.toLowerCase() == "bmw") return "balloon";
        if (this.config.vehicle.make.toLowerCase() == "triumph") return "balloon";
        return "finance";
    }

    setInitCallBack(callback) {
        this.initCallBack = callback;
    }

    addHtml() {
        var classes = [this.wrapperClass, this.themeClass, this.wrapperClassId, "pm-speed-drs-v1"].join(" ");

        //ROOT HTML
        document
            .getElementById(this.config.elementId)
            .insertAdjacentHTML("beforeend", "<div class='" + classes + "'></div>");

        //SPOT FOR MODALS HTML
        document
            .querySelector("body")
            .insertAdjacentHTML("beforeend", "<div class='" + classes + " pmdrs-modals'></div>");

        // document
        //     .querySelector("body")
        //     .insertAdjacentHTML(
        //         "beforeend",
        //         `<link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/5.15.3/css/all.min.css" integrity="sha512-iBBXm8fW90+nuLcSKlbmrPcLa0OT92xO1BIsZ+ywDWZCvqsWgccV3gFoRBv0z+8dLJgyAHIhR35VZc2oM/gI1w==" crossorigin="anonymous" />`
        //     );
    }

    defaultConfig() {
        return {
            recaptchaSiteKey: "your_site_key",
            elementId: "",
            vehicle: {
                finalPrice: "35525", //listedPrice
                retailPrice: "42525", //MSRP
                dealerDiscounts: 0,
                dealerMarkups: 0,
                condition: "new", //new, used
                vin: "1C4HJXDGXMW840919", //,'2C3CCARG3MH649453',//'3N1CN8BV8LL870448',
                stockNumber: "345687",
                statusCode: 'kzx',//kzx, out_of_stock
                mileage: "1",
                year: "2021",
                make: "JEEP",
                model: "Wrangler",
                trim: "123456",
                vehicleKey: "",//example 2021jeepwrangler123456
                label: "2021 Jeep Wrangler 123456",
                vdpUrl: "#vdpUrl",
                imgUrl: "https://es.ramtrucks.com/content/dam/fca-brands/na/ramtrucks/en_us/bhp/lineup/RAM-BHP-LINEUP-TRX-Two-Tone.jpg.image.500.jpg",
                pricing: {}, //PM structure attribute, use with carefull because DRS is not in controll of that structure
                accessories: [], //PM structure attribute, use with carefull because DRS is not in controll of that structure
            },
            hideWidget: false,//to hide widget and auto open dealModal
            forceCalculatorWidget: false,//per-instance override to always use CalculatorWidget, regardless of siteSettings or the ?useCalculatorWidget URL flag
            tabsWidgetClass: 'pmdrs-widget',
            ctaButtonClass: 'pmdrs-widget',
            apr: {
                finance: null,
                lease: null,
            },
        };
    }

    getVehicleRetailPrice() {//use this when you need MSRP
        return this.config.vehicle.retailPrice
        || this.config.vehicle.pricing.data.internet;
    }

    getDraFees() {
        const dealerFees = this.config.vehicle?.pricing?.data?.dealerFees;
        if (dealerFees?.total > 0) return dealerFees;
        return this.config.vehicle?.pricing?.data?.feed?.dra ?? null;
    }

    setDriverConfig() {
        let app = this;
        //SUCCESS
        let successCallback = () => {
            let apr = app.pmdrs.dataDriver.apr;

            if (apr.length != 0) app.init();
        };

        //ERROR
        let errorCallback = () => {
            app.init();
        };

        this.pmdrs.dataDriver.pullApiConfig(successCallback, errorCallback);
    }

    /**
     * [getCreditRangeConfig description]
     * @param  {[type]} dealType lease or finance
     * @return {[type]}          [description]
     */
    getCreditRangeConfig(dealType, mpy = null) {
        return (
            this.pmdrs.dataDriver.getCreditRanges(dealType, mpy) || [
                { "label": "Ultra", "min": 575, "max": 600 },
                { "label": "Super Elite", "min": 601, "max": 639 },
                { "label": "Elite", "min": 640, "max": 674 },
                { "label": "Standard", "min": 675, "max": 699 },
                { "label": "Standard Plus", "min": 700, "max": 739 },
                { "label": "Progressive", "min": 740, "max": 799 },
                { "label": "Progressive Plus", "min": 800, "max": 850 }
            ]
        ).sort((a, b) => {
            return parseInt(b.max) - parseInt(a.max);
        });
    }

    getTermsOptions(dealType, creditRatingLabel, mpy) {
        return this.pmdrs.dataDriver.getTermsOptions(dealType, creditRatingLabel, mpy) 
        || [];
    }

    getDefaultCreditRatingLabel(dealType){//ultra, etc
        return this.pmdrs.dataDriver.getDefaultCreditRatingLabel(dealType);
    }
    

    //array of objects
    financeTable() {
        return (
            this.pmdrs.dataDriver.getAPRFinanceTable() || [
                {
                    label: 'Ultra',
                    terms: {
                        24: "8.55",
                        36: "8.55",
                        48: "8.55",
                        60: "8.55"
                    }
                },
                {
                    label: 'Super Elite',
                    terms: {
                        24: "8.55",
                        36: "8.55",
                        48: "8.55",
                        60: "8.55"
                    }
                },
                {
                    label: 'Elite',
                    terms: {
                        24: "8.55",
                        36: "8.55",
                        48: "8.55",
                        60: "8.55"
                    }
                }
            ]
        );
    }

    //object
    balloonTable() {
        return (
            this.pmdrs.dataDriver.getAPRBalloonTable() || {
                "allowed": true,
                'balloon': [
                    {
                        "Easy Ride": {
                            24: "52",
                            36: "48",
                            48: "43",                            
                        }
                    }
                ],
                "creaditScore": [
                    {label: "Ultra", max: '850', min: '800'},
                    {label: "Super Elite", max: '799', min: '740'},
                    {label: "Elite", max: '739', min: '700'},
                ] ,
                "ratings": [
                    {
                        label: 'Ultra',
                        terms: {
                            24: "8.55",
                            36: "8.55",
                            48: "8.55",
                            60: "8.55"
                        }
                    },
                    {
                        label: 'Super Elite',
                        terms: {
                            24: "8.55",
                            36: "8.55",
                            48: "8.55",
                            60: "8.55"
                        }
                    },
                    {
                        label: 'Elite',
                        terms: {
                            24: "8.55",
                            36: "8.55",
                            48: "8.55",
                            60: "8.55"
                        }
                    }
                ]               
            }
        );
    }

    ttfTable() {//add comments to know whats ttf
        return (
            this.pmdrs.dataDriver.getAPRTTFTable() || {               
                poor: {},
            }
        )
    }

    premierTable() {
        return (
            this.pmdrs.dataDriver.getAPRPremierTable() || {               
                poor: {},
            }
        )
    }

    getFees() {
        return this.pmdrs.dataDriver.getFees() || [];
    }

    getYoutubeOverviewVideo() {
        let hardcodedURL = "https://www.youtube.com/watch?v=2RBBHtZiavw"; // for mcpeeks and speeddra2
        let hardcodedSTS = ["mcpeeksdodgeanaheim", "speeddra2", 'speeddra'];
        if (hardcodedSTS.includes(this.pmdrs.config.accountId)) return hardcodedURL;
        return this.pmdrs.dataDriver.getYoutubeOverviewVideo() || "";
    }

    getYoutubeImagesVideo() {
        return this.pmdrs.dataDriver.getYoutubeImagesVideo() || "";
    }

    getYoutubeTestRideVideo() {
        return this.pmdrs.dataDriver.getYoutubeTestRideVideo() || "";
    }

    getYoutubePreApprovedVideo() {
        return this.pmdrs.dataDriver.getYoutubePreApprovedVideo() || "";
    }

    getOptions() {
        return (
            this.pmdrs.dataDriver.getOptions() || {
                options: {},
            }
        );
    }
    leaseTable() {
        return (
            this.pmdrs.dataDriver.getAPRLeaseTable() || [
                {
                    "mpy" : "10000",
                    "residualPercentage" : {
                        "24" : "70",
                        "27" : "67",
                        "36" : "62",
                        "39" : "60",
                        "42" : "59",
                        "48" : "55"
                    },
                    "ratings" : [
                        {
                            "label" : "Ultra",
                            "terms" : {
                                "24" : "0.00414",
                                "27" : "0.00412",
                                "36" : "0.00385",
                                "39" : "0.00349",
                                "42" : "0.00364",
                                "48" : "0.00318"
                            }
                        }
                    ],
                    "creditScore" : [
                        {
                            "label" : "Ultra",
                            "max" : "850",
                            "min" : "700"
                        }
                    ]
                },
                {
                    "mpy" : "12000",
                    "residualPercentage" : {
                        "24" : "69",
                        "27" : "66",
                        "36" : "61",
                        "39" : "59",
                        "42" : "58",
                        "48" : "54"
                    },
                    "ratings" : [
                        {
                            "label" : "Ultra",
                            "terms" : {
                                "24" : "0.00414",
                                "27" : "0.00412",
                                "36" : "0.00385",
                                "39" : "0.00349",
                                "42" : "0.00364",
                                "48" : "0.00318"
                            }
                        }
                    ],
                    "creditScore" : [
                        {
                            "label" : "Ultra",
                            "max" : "850",
                            "min" : "700"
                        }
                    ]
                },
                {
                    "mpy" : "15000",
                    "residualPercentage" : {
                        "24" : "68",
                        "27" : "65",
                        "36" : "59",
                        "39" : "57",
                        "42" : "56",
                        "48" : "51"
                    },
                    "ratings" : [
                        {
                            "label" : "Ultra",
                            "terms" : {
                                "24" : "0.00414",
                                "27" : "0.00412",
                                "36" : "0.00385",
                                "39" : "0.00349",
                                "42" : "0.00364",
                                "48" : "0.00318"
                            }
                        }
                    ],
                    "creditScore" : [
                        {
                            "label" : "Ultra",
                            "max" : "850",
                            "min" : "700"
                        }
                    ]
                }
            ]
        );
    }

    getLeaseResidualTableByMPY(mpy) {
        let residualTable = null;
        this.leaseTable().forEach((item) => {
            if (item.mpy == mpy) {
                residualTable = item.residualPercentage;
            }
        });
        return residualTable;
    }

    svcQuoteOffer(type, paymentData, successCallback, errorCallback) {
        let app = this;
        this.pmdrs.pmApi.svcQuoteOffer(
            {
                Source: app.pmdrs.config.offerLogixSource,
                VIN: app.config.vehicle.vin,
                CDSID: "405945",
                Term: paymentData.loanMonths,
                DownPayment: paymentData.cashDown,
                Beacon: paymentData.creditRating,
                Odometer: 1000,
                MSRP: app.config.vehicle.finalPrice,
                Purchase: paymentData.sellingPrice,
                sxml: 3,
                // "MileageAllowance": paymentData.mileageAllowance
                // "StyleID": 397921 //chrome style id //this or vin
            },
            successCallback,
            errorCallback
        );
    }

    updateMonthlyPayment() {
        this.getMonthlyPayment(true, "finance", this.paymentData);
    }

    /**
     * [getPayment description]
     * @param  {Boolean} taxes to get taxes or not
     * @param  {string} type            lease of finance
     * @param  {object} paymentData     [description]
     * @param  {function} successCallback
     * @param  {function} errorCallback
     * @return void
     */
    getPayment(taxes, type, paymentData, successCallback, errorCallback) {        
        this.pmdrs.dataDriver.getPayment(taxes, type, paymentData, successCallback, errorCallback);
    }

    getInitialPayment(type, successCallback, errorCallback) {        
        this.pmdrs.dataDriver.getInitialPayment(type, successCallback, errorCallback);
    }

    /**
     * [getCSRIncentives description]
     * @param  {String} dealType        finance lease or cash
     * @param  {[type]} successCallback [description]
     * @param  {[type]} errorCallback   [description]
     * @return {[type]}                 [description]
     */
    getCSRIncentives(dealType, successCallback, errorCallback) {
        this.pmdrs.dataDriver.getCSRIncentives(dealType, successCallback, errorCallback);
    }

    /**
     * @param  {[type]} rating [description]
     * @param  {[type]} months [length of loan]
     * @return {[double]} percentage [0 - 100]
     */
    getFinanceAPR(rating, months) {
        let finance = this.financeTable().find((element) => element.label === rating);
        return finance.terms[months];
    }

    /**
     * @param  {[type]} rating [description]
     * @param  {[type]} months [length of loan]
     * @return {[double]} percentage [0 - 100]
     */
    getLeaseAPR(mpy, rating, months) {
        let lease = this.pmdrs.dataDriver.getLeaseAprTableByMPY(mpy).find((element) => element.label === rating);
        return lease.terms[months];
    }

    /**     
     * @param  {integer} mpy 
     * @param  {integer} months [length of loan]
     * @return {integer} [0 - 100]
     */
    getLeaseResidualPercentage(mpy, months) {
        let residualTable = this.getLeaseResidualTableByMPY(mpy);
        return residualTable[months];
    }

    /**
     * @param {[string]} rating [description]
     * @param {[string]} balloon [name of balloon]
     * @param {[string]} months [length of loan]
     * @returns {[dobule]} percentage [0 - 100]
     */
    getBalloonAPR(rating, months) {
        let balloon = this.balloonTable().balloon[0];
        let apr = parseFloat(balloon["Easy Ride"][months]);
        console.log(months);
        console.log(balloon);
        return apr;
    }

    getPremierAPR(rating, months) {
        let balloon = this.premierTable().balloon[0];
        let apr = parseFloat(balloon['Easy Ride'][months]);
        return apr;
    }

    getTTFAPR(rating, months) {
        let balloon = this.ttfTable().balloon[0];
        let apr = parseFloat(balloon['Easy Ride'][months]);
        return apr;
    }

    getBalloonCreditScoreAPR(rating, months) {
        let creditScore = this.balloonTable().ratings.find((element) => element.label === rating);
        return creditScore.terms[months];
    }

    getPremierCreditScoreAPR(rating, months) {
        let creditScore = this.premierTable().ratings.find((element) => element.label === rating);
        return creditScore.terms[months];
    }

    getTTFCreditScoreAPR(rating, months) {
        let creditScore = this.ttfTable().ratings.find((element) => element.label === rating);
        return creditScore.terms[months];
    }

    loanTermDisplay(months, apr) {
        return months + "  months "; //+ "at " + apr + "% APR";
    }

    creditRatingDisplay(key) {
        switch (key) {
            case "exceptional":
                return "Exceptional";
            case "very_good":
                return "Very Good";
            case "good":
                return "Good";
            case "fair":
                return "Fair";
            case "poor":
                return "Poor";
            default:
                return "";
        }
    }

    getMillesPerYearForLease() {      
        return this.pmdrs.dataDriver.getMillesPerYearOptionsForLease();
    }

    // getSelector(selector){
    // 	return "#" + this.config.elementId + " ."+ this.wrapperClass +" " + selector;
    // }

    getSelector(selector) {
        return "." + this.wrapperClass + "." + this.wrapperClassId + " " + selector;
    }

    setPaymentData(dealType, paymentObject) {
        this.paymentData[dealType] = paymentObject;     
    }

    getDisclaimerText(dealType){
        var paymentData = this.paymentData[dealType];        
        if(!paymentData) return""; //skip, it's trying to get lease on bmwmcconcord

        // PAYMENT DATA DISCLAIMER AS FIRST OPTION
        if(paymentData && paymentData.disclaimerText){
            return paymentData.disclaimerText;
        }

        let discounts = this.config.vehicle.pricing.data.discount ?? [];
        let text = "";//think a better name
        if (discounts.cms && discounts.cms.items && discounts.cms.items.length > 0) {
            text = "";
            text += discounts.cms.items.map(item => `$${item.value} ${item.label}`).join(' and ');
            text += ", ";
        }
        
        
        let fees = this.getFees();
        let result = fees.length > 0 ? " plus " : "";//think a better name
        result += fees
            .map(item => `${item.name} $${item.value}`) // Map each object to the desired string format
            .join(', '); // Join the strings with a comma and space     
        
        if (dealType != "cash") {//TODO, get paymentData for cash type, even empty
            var disclaimerParams = {            
                discountsText: text,
                msrp: this.getVehicleRetailPrice(),
                term: paymentData.term,
                downPayment: paymentData.downPayment,
                dealerName: this.pmdrs.config.dealerName,
                dealerPhone: this.pmdrs.config.dealerPhone,
                finalPrice: this.config.vehicle.finalPrice,
                addedDealerMarkups: result
            }
        }
        
        switch(dealType){
            case 'balloon':    
                disclaimerParams.apr = paymentData.ratingBalloonAPR;                    
                disclaimerParams.balloonPayment = paymentData.balloonPayment;
                return this._getDisclaimerTextBalloon(disclaimerParams);            
            case 'premier':
                disclaimerParams.apr = paymentData.ratingBalloonAPR;                    
                disclaimerParams.balloonPayment = paymentData.balloonPayment;
                return this._getDisclaimerTextPremier(disclaimerParams);
            case 'cash':
                return this._getDisclaimerTextCash();
            case 'ttf':
                disclaimerParams.apr = paymentData.ratingBalloonAPR;                    
                disclaimerParams.balloonPayment = paymentData.balloonPayment;
                return this._getDisclaimerTextTTF(disclaimerParams);
            case 'finance':
            default:
                disclaimerParams.apr = paymentData.moneyFactor;//does exist the scneario where finance object has a different structure? apr?
                return this._getDisclaimerTextFinance(disclaimerParams);                
        }
    }

    _getDisclaimerTextFinance({ 
        msrp, 
        term, 
        apr,//float 
        downPayment, 
        dealerName, 
        dealerPhone,
        addedDealerMarkups 
    }){        
        let destinationFee =0;//temp
        if(this.pmdrs.isSosoSite() || this.pmdrs.isMotosAmericaSite()){   
            if(this.isVehicleDucati()){
                return `Disclaimer: Estimated finance payments is based on $${msrp} MSRP, ${term} month contract,
                ${apr}% APR, 30 days to first payment and $${downPayment} down payment. Excludes taxes, ${addedDealerMarkups}
                added dealer markup, ${destinationFee} factory destination charge license, registration and doc
                fees. Financing offered to well qualified customers by ${dealerName}. Subject to credit
                approval. Not all applicants will qualify. Actual credit terms for approved applicant may differ
                based on applicant&#39;s creditworthiness, amount financed and length of term. Loan quoting is a
                dynamic process so payments and terms are subject to change prior to contract execution by all
                parties. All advertised vehicles are subject to prior sale. We reserve the right to make changes
                without notice, and are not responsible for errors or omissions. Contact ${dealerName} at
                ${dealerPhone} for more information. Financing is subject to credit approval and not all a
            pplicants will qualify. Rates, terms, and offers may vary based on credit history and lender requirements. 
            The listed price is an estimate and may change based on taxes, fees, and optional features. For full details 
            on pricing, financing options, and eligibility, please visit the dealer.`;
            }
            //  default soso
            return `Disclaimer: Estimated finance payments is based on $${msrp} MSRP, ${term} month contract,
                ${apr}% APR, 30 days to first payment and $${downPayment} down payment. Excludes taxes, ${addedDealerMarkups}
                added dealer markup, license, registration and doc fees. Financing offered to well qualified
                customers by ${dealerName}. Subject to credit approval. Not all applicants will qualify. Actual
                credit terms for approved applicant may differ based on applicant&#39;s creditworthiness, amount
                financed and length of term. Loan quoting is a dynamic process so payments and terms are
                subject to change prior to contract execution by all parties. All advertised vehicles are subject to
                prior sale. We reserve the right to make changes without notice, and are not responsible for errors
                or omissions. Contact ${dealerName} at ${dealerPhone} for more information. Financing is subject to credit approval and not all a
            pplicants will qualify. Rates, terms, and offers may vary based on credit history and lender requirements. 
            The listed price is an estimate and may change based on taxes, fees, and optional features. For full details 
            on pricing, financing options, and eligibility, please visit the dealer.`
        }
        var brand = this.isBMW() ? " BMW" : "";//just for now, and for generic texts
        // default
        return `Estimated payments exclude applicable taxes, title, registration, 
        license, and documentary fees, and will vary depending upon the final price
         and terms agreed upon between you and your${brand} Dealer. Financing is subject to credit approval and not all a
            pplicants will qualify. Rates, terms, and offers may vary based on credit history and lender requirements. 
            The listed price is an estimate and may change based on taxes, fees, and optional features. For full details 
            on pricing, financing options, and eligibility, please visit the dealer.`;
    }
 
    _getDisclaimerTextBalloon({
        msrp,
        discountsText,
        balloonPayment,
        term,
        downPayment,
        dealerName,
        dealerPhone,
        apr,//float
        addedDealerMarkups
        }){        
                   
        if(this.pmdrs.isSosoSite()){            
            return `Easy Ride example monthly payment is based on $${msrp} MSRP, ${term} month contract,
            ${apr}% APR, 30 days to first payment, $${downPayment} down payment and a $${balloonPayment} balloon
            payment. Excludes taxes, ${addedDealerMarkups} added dealer markup, license, registration and doc fees. Easy
            Ride is a retail installment sales contract with a balloon payment due at or before the end of initial
            ${term} month term. Easy Ride sales contracts are offered to well qualified customers by
            ${dealerName} and assigned to BMW Financial Services NA, LLC or BMW Bank of North
            America. Subject to credit approval. Not all applicants will qualify. Actual credit terms for
            approved applicant may differ based on applicant&#39;s creditworthiness, amount financed and length
            of term. Loan quoting is a dynamic process so payments and terms are subject to change prior to
            contract execution by all parties. All advertised vehicles are subject to prior sale. We reserve the
            right to make changes without notice, and are not responsible for errors or omissions. Contact
            ${dealerName} at ${dealerPhone} for more information. Financing is subject to credit approval and not all 
            applicants will qualify. Rates, terms, and offers may vary based on credit history and lender requirements. 
            The listed price is an estimate and may change based on taxes, fees, and optional features. For full details 
            on pricing, financing options, and eligibility, please visit the dealer.`            
        }
        if (this.isVehicleTriumph()) {
            return `Triumph Triple Financing example monthly payment is based on $${msrp} MSRP, ${term} month contract,
            ${apr}% APR, 30 days to first payment, $${downPayment} down payment and a $${balloonPayment} balloon
            payment. Excludes taxes, ${addedDealerMarkups} added dealer markup, license, registration and doc fees. Triumph Triple Financing is a retail installment sales contract with a balloon payment due at or before the end of initial
            ${term} month term. Triumph Triple Financing sales contracts are offered to well qualified customers by
            ${dealerName} and assigned to Freedom Road Financial. Subject to credit approval. Not all applicants will qualify. Actual credit terms for
            approved applicant may differ based on applicant&#39;s creditworthiness, amount financed and length
            of term. Loan quoting is a dynamic process so payments and terms are subject to change prior to
            contract execution by all parties. All advertised vehicles are subject to prior sale. We reserve the
            right to make changes without notice, and are not responsible for errors or omissions. Contact
            ${dealerName} at ${dealerPhone} for more information. Financing is subject to credit approval and not all a
            pplicants will qualify. Rates, terms, and offers may vary based on credit history and lender requirements. 
            The listed price is an estimate and may change based on taxes, fees, and optional features. For full details 
            on pricing, financing options, and eligibility, please visit the dealer.`
        }
        //DEFAULT
        return `Easy Ride example monthly payment is based on $${msrp} MSRP 
        minus ${discountsText} ${addedDealerMarkups}, ${term} month contract, ${apr}% APR, 30 days to first 
        payment, $${downPayment} down payment and a $${balloonPayment} balloon payment. Excludes tax 
        and DMV fees.<br>
        <span class='discl-small-text'>
        Conditions and Legal Disclaimer: Easy Ride is a retail installment sales 
        contract with a balloon payment. Financing provided to well qualified 
        customers by participating BMW Motorcycle dealers and assigned to BMW Financial 
        Services NA, LLC or BMW Bank of North America. Fees and other details are subject 
        to change. BMW Motorrad USA is not responsible for errors. Price examples exclude tax,
            title, and registration fees. Actual credit terms for approved applicant may 
            differ based on applicant's creditworthiness, amount financed and length of term. 
            Program not offered in NC, ND, NH, NV, PA, & WV. The total amount financed must 
            be greater than $10,000 in HI and MD. In NJ, the selling price must exceed $10,000. 
            Easy Ride products may not be used in ME for contracts with a term of less 
            than ${term} months. Subject to credit approval.
            </span> Financing is subject to credit approval and not all a
            pplicants will qualify. Rates, terms, and offers may vary based on credit history and lender requirements. 
            The listed price is an estimate and may change based on taxes, fees, and optional features. For full details 
            on pricing, financing options, and eligibility, please visit the dealer.`;
    }

    _getDisclaimerTextCash() {
        switch (this.pmdrs.config.accountId) {
            case 'clovischryslerdodgejeepram':
                    return "We will make our best efforts that posted prices are always accurate however, we are not responsible for any typographical or other errors that may appear on the site. If the posted price for a vehicle or service is incorrect due to a typographical or other error, such as data transmission, etc., this Dealership or Pixel Motion, Inc. are only responsible for the correct price, which will be provided as soon as we are made aware of such error(s). Ultimately, it is your responsibility to ensure that the information is 100% accurate with the Dealer. Posted vehicle images and descriptions on our website is representative to what is provided by our suppliers. Please note that the actual vehicle may slightly differ from its specifications and/or images. The Dealership is not responsible for any typographical, pricing, product specifications, advertising or shipping errors. Advertised prices and availability are subject to change without notice. In the event a vehicle is posted at an incorrect price due to these errors, or if an error in pricing was received from our suppliers, the Dealership reserves the right to refuse and/or cancel these orders. " + 
                    "*Sale or Net Price including a Factory Rebate, if applicable, on this vehicle is valid on a financed purchase only by an individual for their personal use. The sale price does not apply to a lease, out-of-state buyer, or 0% financed offer. The Factory Rebates may not be available on this vehicle if you elect to take advantage of a Special Alternative APR or Special Lease program. Some Factory Rebates are California Resident specific and may vary for residents of other states. No sales to dealers, brokers, or exporters for out-of-state purchase. Customers must be present to purchase. If shipping is required, dealership must facilitate; no exceptions. Please contact us for special multi-vehicle or fleet pricing. Prices are plus government fees and taxes, any finance charges, $85 documentary fee, $33 electronic registration fee, any emission testing charge and $1.75 per new tire based on state-tire fee. We make every effort to provide accurate information, We are not responsible for typographical errors, please verify with sales consultant before purchasing. Leasing & financing are available on approved credit. Trade-ins accepted. Subject to prior sale. This price is only available for CA resident buyers who obtain an auto loan through the dealership. Cash price, using an outside lender or 0% financing offer will include an additional $1,000 fee. S.W.A.T Vehicle Tracking has been added to all vehicles and is not reflected in the final sale or net price at $1,595. This price is only available for CA resident buyers who obtain an auto loan through the dealership.";
        }
        var brand = this.isBMW() ? " BMW" : "";//just for now, and for generic texts
        return `Estimated payments exclude applicable taxes, title, registration, license, and documentary fees, 
        and will vary depending upon the final price and terms agreed upon between you and your${brand} Dealer`;
    }

    _getDisclaimerTextTTF({
        msrp,
        discountsText,
        balloonPayment,
        term,
        downPayment,
        dealerName,
        dealerPhone,
        apr,//float
        addedDealerMarkups
        }) {
        return `Triumph Triple Financing example monthly payment is based on $${msrp} MSRP, ${term} month contract,
            ${apr}% APR, 30 days to first payment, $${downPayment} down payment and a $${balloonPayment} balloon
            payment. Excludes taxes, ${addedDealerMarkups} added dealer markup, license, registration and doc fees. Triumph Triple Financing is a retail installment sales contract with a balloon payment due at or before the end of initial
            ${term} month term. Triumph Triple Financing sales contracts are offered to well qualified customers by
            ${dealerName} and assigned to Freedom Road Financial. Subject to credit approval. Not all applicants will qualify. Actual credit terms for
            approved applicant may differ based on applicant&#39;s creditworthiness, amount financed and length
            of term. Loan quoting is a dynamic process so payments and terms are subject to change prior to
            contract execution by all parties. All advertised vehicles are subject to prior sale. We reserve the
            right to make changes without notice, and are not responsible for errors or omissions. Contact
            ${dealerName} at ${dealerPhone} for more information. Financing is subject to credit approval and not all a
            pplicants will qualify. Rates, terms, and offers may vary based on credit history and lender requirements. 
            The listed price is an estimate and may change based on taxes, fees, and optional features. For full details 
            on pricing, financing options, and eligibility, please visit the dealer.`
    }

    _getDisclaimerTextPremier({
        msrp,        
        discountsText,
        balloonPayment,
        term,
        downPayment,
        dealerName,
        dealerPhone,
        finalPrice,
        apr,//float
        addedDealerMarkups
        }){        
                
        let destinationFee = 0;
        if((this.pmdrs.isSosoSite() || this.pmdrs.isMotosAmericaSite()) 
            && this.isVehicleDucati()){        
            return `Ducati Premier example monthly payment is based on $${msrp} MSRP, ${term} month contract,
            ${apr}% APR, 30 days to first payment, $${downPayment} down payment and a $${balloonPayment} balloon
            payment. Excludes taxes, ${addedDealerMarkups} added dealer markup, ${destinationFee} factory destination charge, 
            license, registration and doc fees. Ducati Premier is a retail installment sales contract with a
            balloon payment due at or before the end of initial ${term} month term. Ducati Premier sales
            contracts are offered to well qualified customers by ${dealerName} and assigned to VW Credit,
            Inc. or Ducati Financial Services. Subject to credit approval. Not all applicants will qualify. Actual
            credit terms for approved applicant may differ based on applicant&#39;s creditworthiness, amount
            financed and length of term. Loan quoting is a dynamic process so payments and terms are
            subject to change prior to contract execution by all parties. All advertised vehicles are subject to
            prior sale. We reserve the right to make changes without notice, and are not responsible for errors
            or omissions. Contact ${dealerName} at ${dealerPhone} for more information. Financing is subject to credit approval and not all a
            pplicants will qualify. Rates, terms, and offers may vary based on credit history and lender requirements. 
            The listed price is an estimate and may change based on taxes, fees, and optional features. For full details 
            on pricing, financing options, and eligibility, please visit the dealer.`;            
        }

        downPayment = Math.floor(parseFloat(finalPrice * 0.20));//why not paymentData.downPayment to by dynamic? 
        //DEFAULT
        let content = `Premier monthly based on $${finalPrice} MSRP minus ${discountsText}${addedDealerMarkups}, 
            ${term} month contract, ${apr} % APR, 30 days to first payment, 
            $${downPayment} down payment and a $${balloonPayment} balloon payment. Financing is subject to credit approval and not all a
            pplicants will qualify. Rates, terms, and offers may vary based on credit history and lender requirements. 
            The listed price is an estimate and may change based on taxes, fees, and optional features. For full details 
            on pricing, financing options, and eligibility, please visit the dealer.`;

        return content;
    }
}
